import { useNavigate, useLocation } from "react-router-dom";
import { Swords, Anchor, Plane } from "lucide-react";

const BRANCHES = [
  { key: "army",     label: "Army",      Icon: Swords, color: "#4D7C0F", bg: "#F7FEE7", ring: "#84CC16" },
  { key: "navy",     label: "Navy",      Icon: Anchor, color: "#1E3A8A", bg: "#EFF6FF", ring: "#3B82F6" },
  { key: "airforce", label: "Air Force", Icon: Plane,  color: "#075985", bg: "#F0F9FF", ring: "#0EA5E9" },
];

export default function BranchSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const active = location.pathname.startsWith("/branch/")
    ? location.pathname.split("/branch/")[1]
    : null;

  function handleClick(key) {
    if (active === key) {
      navigate(-1);
    } else {
      navigate(`/branch/${key}`);
    }
  }

  return (
    <div
      className="hidden md:flex fixed right-4 top-1/2 -translate-y-1/2 z-50 flex-col gap-3"
      style={{ filter: "drop-shadow(0 4px 16px rgba(0,0,0,0.12))" }}
    >
      {BRANCHES.map(({ key, label, Icon, color, bg, ring }) => {
        const isActive = active === key;
        return (
          <div key={key} className="group relative flex items-center justify-end">
            {/* Slide-in label */}
            <span
              className="absolute right-[52px] whitespace-nowrap text-xs font-bold px-2.5 py-1 rounded-lg pointer-events-none
                opacity-0 group-hover:opacity-100 transition-all duration-200 translate-x-2 group-hover:translate-x-0"
              style={{ background: color, color: "#fff" }}
            >
              {label}
            </span>

            {/* Icon button */}
            <button
              onClick={() => handleClick(key)}
              title={label}
              className="w-11 h-11 rounded-full flex items-center justify-center transition-all duration-200 border-2"
              style={isActive
                ? { background: color, borderColor: color, boxShadow: `0 0 0 3px ${ring}55` }
                : { background: bg,    borderColor: ring }
              }
            >
              <Icon size={18} color={isActive ? "#fff" : color} strokeWidth={2} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
